import React from 'react';
import { Button } from './ui/button';

export default class AppErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main id="main-content" className="mx-auto flex min-h-screen max-w-xl flex-col justify-center px-6 py-12">
        <h1 className="font-display text-3xl">This page needs a fresh start.</h1>
        <p role="alert" className="mt-4 text-base leading-relaxed text-muted-foreground">Something interrupted the page. Reload to try again. Reloading will not submit an order or payment.</p>
        <Button className="mt-6 min-h-11 self-start" onClick={() => window.location.reload()}>Reload page</Button>
        <a href="/" className="mt-4 inline-flex min-h-11 items-center text-sm text-primary underline">Return to Batchtrue</a>
      </main>
    );
  }
}
